<template>
  <v-row class="py-3" no-gutters>
    <v-sheet color="transparent" width="200">
      <v-card class="mb-4" outlined width="180">
        <v-card-text>
          <v-responsive class="align-center text-center" :aspect-ratio="1/1">
          <img :src="require(`@/assets/appAsset-bankingLogo__santander.svg`)" alt="santander brasil" width="90%">
          </v-responsive>
        </v-card-text>
      </v-card>
      <v-list class="pl-0" color="transparent">
        <v-list-item class="pl-0">
          <v-list-item-content>
            <v-list-item-title class="body-2 text--secondary font-weight-medium">Sitio web</v-list-item-title>
            <v-list-item-subtitle>
              <v-btn href="https://www.santander.com.br/empresas" target="_blank" color="primary" text :ripple="false">Visitar el sitio<v-icon right small>mdi-open-in-new</v-icon></v-btn>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="pl-0">
          <v-list-item-content>
            <v-list-item-title class="body-2 text--secondary font-weight-medium">Guía de integración</v-list-item-title>
            <v-list-item-subtitle>
              <v-btn :href="`${$DOCS_BASE}/integrations/banking/santander-brasil`" target="_blank" color="primary" text :ripple="false">Ir a la documentación<v-icon right small>mdi-open-in-new</v-icon></v-btn>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="pl-0">
          <v-list-item-content>
            <v-list-item-title class="body-2 text--secondary font-weight-medium">Disponible en</v-list-item-title>
            <v-list-item-subtitle>
              <img class="mt-2" src="../../assets/appAsset-flag--BR.svg" alt="brasil" height="16px">
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="pl-0">
          <v-list-item-content>
            <v-list-item-title class="body-2 text--secondary font-weight-medium">Funciona con</v-list-item-title>
            <v-list-item-subtitle>
              <v-chip class="mt-2" color="indigo" dark small>Pagos</v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-sheet>

    <v-col cols="8">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="ml-n1 subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{ name: 'Integrations' }" class="subtitle-1 routerLink font-weight-medium">Integraciones</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>Santander Brasil
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background overflow-y-auto" style="height: calc(100vh - 238px)">
          <v-row class="fill-height" no-gutters>
            <!-- loader -->
            <template v-if="$store.state.banks.retrieveLoader">
              <v-col>
                <v-skeleton-loader type="article, actions" />
              </v-col>
            </template>
            <!-- end loader -->

            <!-- installed diagram -->
            <template v-else-if="installed">
              <v-col class="d-flex justify-end align-center">
                <v-avatar class="elevation-2" color="white" size="80">
                  <img src="../../assets/appAsset-brand--piriod-icon.svg" alt="piriod" style="width:30px;">
                </v-avatar>
              </v-col>
              <v-col cols="5" class="d-flex justify-center align-center">
                <v-progress-linear buffer-value="0" color="success" reverse stream value="0" height="24">
                  <template v-slot:default>
                    <v-chip class="d-block" color="green accent-4" dark small>Integración activa</v-chip>
                  </template>
                </v-progress-linear>
              </v-col>
              <v-col class="d-flex justify-start align-center">
                <v-avatar class="elevation-2" color="white" size="80">
                  <img src="../../assets/appAsset-bankingLogo__cl_banco_santander_Min.svg" alt="santander brasil" style="width:30px;">
                </v-avatar>
              </v-col>
            </template>
            <!-- end installed diagram -->

            <!-- connection -->
            <v-col v-else>
              <span class="d-block pt-6 px-5 background text--primary">Utiliza las credenciales de acceso <span class="text--secondary font-weight-medium">Client ID y Client Secret</span> generados desde el portal de desarrolladores de Santander.</span>

              <v-list class="py-3" color="background" dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Client ID</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="5" class="pa-0">
                        <v-text-field v-model="$v.connection.credentials.client_id.$model" autocomplete="new-password" background-color="white" dense :error="$v.connection.credentials.client_id.$error" hide-details maxlength="64" outlined required single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Client secret</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="3" class="pa-0">
                        <v-text-field v-model="$v.connection.credentials.client_secret.$model" autocomplete="new-password" background-color="white" dense :error="$v.connection.credentials.client_secret.$error" hide-details maxlength="24" outlined required single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <span class="d-block px-5 pt-3 background text--secondary subtitle-2 font-weight-medium">Certificado</span>
              <span class="d-block px-5 background text--primary">Carga el mismo certificado digital que utilizas para la firma electrónica de las notas fiscales.</span>

              <v-list class="pt-5 v-sm-text-fields" color="background">
                <v-list-item>
                  <v-list-item-content class="py-1">
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">
                      Archivo del certificado
                      <span class="ml-1 body-2 text--primary font-weight-regular">(debe ser en formato .pfx)</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-file-input v-model="connection.credentials.cert_file" accept="application/x-pkcs12" background-color="transparent" chips :error="$v.connection.credentials.cert_file.$error" flat hide-details prepend="mdi-paper-clip" placeholder="Haz clic para seleccionar un archivo" solo type="file" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="py-1">
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">Contraseña</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="3" class="pa-0">
                        <v-text-field v-model="$v.connection.credentials.cert_password.$model" background-color="white" dense :error="$v.connection.credentials.cert_password.$error" hide-details maxlength="24" outlined single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list class="py-3 v-sm-text-fields" color="background">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">Ambiente</v-list-item-title>
                    <v-list-item-subtitle class="ml-1 body-2 text--primary font-weight-regular">
                      <template v-if="installed">Ambiente de Santander en el que se están creando boletos.</template>
                      <template v-else>Define el ambiente de Santander en el que quieres crear boletos.</template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="8" class="pa-0">
                        <v-radio-group class="ml-1" v-model="connection.test_mode" :disabled="installed">
                          <v-radio :value="false">
                            <template v-slot:label>
                              <span class="body-2 text--secondary font-weight-medium">Producción</span>
                              <span class="ml-2 body-2 text--primary  font-italic font-weight-regular">(se crearán boletos reales)</span>
                            </template>
                          </v-radio>
                          <v-radio :value="true">
                            <template v-slot:label>
                              <span class="body-2 text--secondary font-weight-medium">Pruebas</span>
                              <span class="ml-2 body-2 text--primary  font-italic font-weight-regular">(se crearán boletos ficticios)</span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <!-- end connection -->
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn v-if="installed" @click="destroyConnection" dark color="red">Desconectar</v-btn>
          <v-btn v-else @click="createConnection" :loading="loaderConnect" color="primary">Conectar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, required } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    connection: {
      provider: 'bankops',
      bank: 'br_santander',
      credentials: {
        cert_file: null,
        cert_password: null,
        client_id: null,
        client_secret: null
      },
      test_mode: false
    },
    installed: false,
    loaderConnect: false
  }),
  computed: mapState({
    instance: state => state.banks.connectionsDetail
  }),
  created () {
    this.retrieveConnection()
  },
  methods: {
    createConnection () {
      this.$v.connection.$touch()
      if (this.$v.connection.$invalid) {
        return false
      }

      this.loaderConnect = true

      const payload = new FormData()
      payload.append('bank', this.connection.bank)
      payload.append('credentials.cert_file', this.connection.credentials.cert_file, this.connection.credentials.cert_file.name)
      payload.append('credentials.cert_password', this.connection.credentials.cert_password)
      payload.append('credentials.client_id', this.connection.credentials.client_id)
      payload.append('credentials.client_secret', this.connection.credentials.client_secret)
      payload.append('provider', this.connection.provider)
      payload.append('test_mode', this.connection.test_mode)

      this.$store.dispatch('banks/CREATE', {
        resource: 'banks/connections',
        payload: payload,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(() => {
        this.$dialog.message.info(`Se ha activado la integración con Santander Brasil.`)
        this.installed = true
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderConnect = false
      })
    },
    destroyConnection () {
      this.$dialog.warning({
        title: `Desconectar Santander Brasil`,
        text: `
          <span class="d-block mb-4">¿Estás seguro de desconectar esta integración?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer.</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('banks/DESTROY', {
                resource: 'banks/connections',
                id: 'bankops'
              })
              .then(() => {
                this.$dialog.message.info(`Se ha desconectado la integración con Santander Brasil.`)

                // reset connection
                this.connection = {
                  provider: 'bankops',
                  bank: 'br_santander',
                  credentials: {
                    cert_file: null,
                    cert_password: null,
                    client_id: null,
                    client_secret: null
                  },
                  test_mode: false
                }
                this.$v.$reset()
                this.installed = false
              })
              .catch((error) => {
                this.$dialog.message.warning(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    retrieveConnection () {
      this.$store.dispatch('banks/RETRIEVE', {
        resource: 'banks/connections',
        id: 'bankops'
      })
      .then(() => {
        this.installed = true
      })
      .catch(() => {
        this.installed = false
      })
    }
  },
  validations: {
    connection: {
      credentials: {
        cert_file: {
          required
        },
        cert_password: {
          required,
          maxLength: maxLength(128)
        },
        client_id: {
          required,
          maxLength: maxLength(64)
        },
        client_secret: {
          required,
          maxLength: maxLength(24)
        }
      }
    }
  }
}
</script>